import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";
import {Link} from "react-router-dom";


const PortfolioList = [
    {
        image: 'image-1',
        category: 'Sosyal Medya',
        title: ' Etkili sosyal medya stratejileriyle marka bilinirliğini artırdık.'
    },
    {
        image: 'image-2',
        category: 'E-Ticaret',
        title: ' Etkili sosyal medya stratejileriyle marka bilinirliğini artırdık.'
    },
    {
        image: 'image-3',
        category: 'SEO',
        title: ' SEO çalışmalarıyla web sitesinin organik trafiğini %70 oranında yükselttik.'
    },
    {
        image: 'image-4',
        category: 'Kurumsal Kimlik',
        title: ' Marka kimliğini yeniden tanımlayarak görsel tutarlılığı sağladık.'
    },
    {
        image: 'image-3',
        category: 'Google Ads',
        title: ' Dönüşüm odaklı Google Ads kampanyası ile reklam bütçesini optimize ederek satışları %40 artırdık.'
    },
    {
        image: 'image-4',
        category: 'Prodüksiyon',
        title: ' Yaratıcı video içerikleri üreterek markanın sosyal medya etkileşimlerini %60 oranında artırdık."'
    }
]

class Portfolio extends Component{
    render(){
        let title = 'Çalışmalarımız',
        description = 'Ketçap Ajans olarak, her projede yenilikçi ve yaratıcı çözümler sunarak markalarımızın dijital dünyada öne çıkmasını sağlıyoruz. İşte başarımızın arkasındaki bazı örnek çalışmalar.';
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-slick-activation mt--70 mt_sm--40">
                        <Slider {...portfolioSlick2}>
                            {PortfolioList.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <div className={`thumbnail ${value.image}`}></div>
                                        <div className={`bg-blr-image ${value.image}`}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>{value.category}</p>
                                            <h4 className="title"><a href="/portfolio-details">{value.title}</a></h4>
                                            <div className="portfolio-button">
                                                <a className="rn-btn" href="/portfolio-details">Detaylar</a>
                                            </div>
                                        </div>
                                    </div>
                                    <Link className="link-overlay" to="/portfolio-details"></Link>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;